import Action from "../actions/model"
import { cloneDeep, orderBy } from "lodash";
import { make } from "vuex-pathify";
import Chart from "./model";
import store from "../..";
import Insight from "../insights/model";
import Client from "../clients/model";

const chartDefault = {
    datasets: null,
    dimension: null,
    dimensions: null,
    insightGivers: [],
    insights:[],
    is_inverted: false,
    metrics: [],
    number_format: 'float',
    tags: {
        category: [],
        channel: [],
    },
    title: null,
    type: null,
}

const state = {
    loading: false,
    creating: false,
    updating: false,
    destroying: false,
    chart: cloneDeep(chartDefault),
    charts: [],
    sortBy: 'order,created_at',
    filters: {
        // favourites: true,
        // tags: [
        //     {
        //         id: 14,
        //         name: 'growth',
        //         slug: 'growth',
        //         type: 'category'
        //     }
        // ]
    },
    limit: 50,
    pagination: {
        current_page: 1,
        from: null,
        last_page: null,
        path: null,
        per_page: null,
        to: null,
        total: null
    },
};

const mutations = make.mutations(state);

const actions = {
    async load({ commit }, id) {
        let chart = {};

        try {
            commit("loading", Chart.$find(id));
            chart = await store.get("charts/loading");

            commit("loading", false);
        } catch (error) {
        //
        }

        let charts = store.get("charts/charts").map(item => {
            if (item.id === chart.id) {
                Object.assign(item, chart)

                return item
            }

            return item
        })

        commit("charts", charts)
    },

    async loadChartActions({ commit }, payload) {
        let chart = payload
        let actions = []

        try {
            let querySettings = chart.query_settings.action
            let currentPage = querySettings.pagination.current_page
            let filters = querySettings.filters
            let limit = querySettings.limit
            let loading = querySettings.loading
            let sortBy = querySettings.sortBy
            let query = chart.chartActions().orderBy(sortBy)

            for (const key in filters) {
                if (filters.hasOwnProperty(key)) {
                    query.where(key, filters[key])

                    if (key === 'search' && filters[key].length !== 0) {
                        currentPage = 1
                    }
                }
            }

            query.page(currentPage).limit(limit)

            loading = true
            actions = await query.get()
            loading = false
        } catch (error) {
            //
        }

        let charts = store.get("charts/charts").map(item => {
            if (item.id === chart.id) {
                item.query_settings.action.pagination = actions.meta
                item.actions = actions.data

                return item
            }

            return item
        })

        commit("charts", charts)
    },

    async loadCharts({ commit }, filter = true) {
        let client = new Client({id: store.get('auth/client@id')})
        let chart = new Chart().for(client)
        let charts = null

        try {
            let filters = store.get("charts/filters")
            let limit = store.get("charts/limit")
            let pagination = store.get("charts/pagination")
            let query = chart
                .orderBy(store.get("charts/sortBy"))

            if (filter) {
                for (const key in filters) {
                    if (filters.hasOwnProperty(key)) {
                        if (key === 'tags') {
                            query = buildTagFilters(query, filters[key])
                        } else {
                            query.where(key, filters[key])

                            if (key === 'search' && filters[key].length !== 0) {
                                store.set("charts/pagination@current_page", 1)
                            }
                        }
                    }
                }

                query.page(store.get("charts/pagination@current_page"))
            }

            query.page(pagination.current_page).limit(limit)

            commit("loading", query.get())
            charts = await store.get("charts/loading");

            commit("loading", false);
        } catch (error) {
            console.log(error);

        }

        let data = charts.data.map(chartData => {
            store.get("charts/charts").forEach(item => {
                if (item.id === chartData.id) {
                    chartData.actions = item.actions
                    chartData.insights = item.insights
                    chartData.query_settings = item.query_settings
                }
            })

            return chartData
        })

        commit("charts", data);
        commit("pagination", charts.meta);
    },

    async loadChartInsights({ commit }, payload) {
        let chart = payload
        let insights = []

        try {
            let querySettings = chart.query_settings.insight
            let currentPage = querySettings.pagination.current_page
            let filters = querySettings.filters
            let limit = querySettings.limit
            let loading = querySettings.loading
            let sortBy = querySettings.sortBy
            let query = chart.chartInsights().orderBy(sortBy)

            for (const key in filters) {
                if (filters.hasOwnProperty(key)) {
                    query.where(key, filters[key])

                    if (key === 'search' && filters[key].length !== 0) {
                        currentPage = 1
                    }
                }
            }

            query.page(currentPage).limit(limit)

            loading = true
            insights = await query.get()
            loading = false
        } catch (error) {
            //
        }

        let charts = store.get("charts/charts").map(item => {
            if (item.id === chart.id) {
                item.query_settings.insight.pagination = insights.meta
                item.insights = insights.data

                return item
            }

            return item
        })

        commit("charts", charts)
    },

    async loadChartData({ commit }, payload) {
        let data = null
        // let chart = new Chart({id: payload.id, start_date: payload.start_date, end_date: payload.end_date, datasets: payload.datasets, dimensions: payload.dimensions})
        let chart = new Chart(payload)

        try {
            chart.loading = true;
            data = await chart.getData();

            chart.loading = false;
        } catch (error) {
            // throw error
        }

        if (data.notes.status === 'error') {
            throw new MetricDataException(data.notes.error)
        }

        payload.datasets = data.datasets
        payload.dimensions = data.dimensions
    },

    async loadChartMetrics({ commit }, payload) {
        let data = {}
        let chart = payload.id ? payload : new Chart(store.get("charts/chart"))

        try {
            commit("loading", chart.getMetricData(chart.data_source));
            data = await store.get("charts/loading");

            commit("loading", false);
        } catch (error) {
        //
        }

        return data
    },

    // async loadChartInsightGivers({ commit }, payload) {
    //     let chart = payload
    //     let givers = []

    //     try {
    //         givers = await chart.getGivers()
    //     } catch (error) {
    //         //
    //     }

    //     chart.insightGivers = givers
    // },

    resetChart({ commit }) {
        commit("chart", cloneDeep(chartDefault))
    },

    async create({commit, dispatch}, payload) {
        let client = new Client({id: store.get('auth/client@id')})
        let chart = new Chart(payload).for(client)
        let response = null

        chart.chart_type_id = chart.type.id
        chart.client_id = store.get("auth/client@id")

        try {
            commit("creating", chart.save());
            response = await store.get("charts/creating");
        } catch (error) {
            throw error
        } finally {
            commit("creating", false);
        }

        let charts = store.get("charts/charts")

        charts.push(new Chart(response))

        charts = orderBy(charts, ['order', 'updated_at'], ['asc', 'desc'])

        commit("charts", charts)
    },

    async createAction({commit, dispatch}, {chart, action}) {
        action = new Action(action).for(chart)

        try {
            await action.save()
        } catch (error) {
            throw error
        }

        dispatch('loadChartActions', chart)
    },

    async createInsight({commit, dispatch}, {chart, insight}) {
        insight = new Insight(insight).for(chart)

        try {
            await insight.save()
        } catch (error) {
            throw error
        }

        dispatch('loadChartInsights', chart)
    },

    async update({commit, dispatch}, payload) {
        let chart = payload

        chart.chart_type_id = chart.type.id

        try {
            commit("loading", chart.save());
            chart = await store.get("charts/loading");
            commit("loading", false);
        } catch (error) {
            throw error
        }

        dispatch("load", chart.id)
        // dispatch("loadChartData", chart)
    },

    async destroy({commit, dispatch}, payload) {
        let chart = new Chart(payload)

        try {
            commit("loading", chart.delete());
            await store.get("charts/loading");
            commit("loading", false);
        } catch (error) {
            throw error
        }

        let charts = store.get('charts/charts').filter(c => c.id !== chart.id)

        commit('charts', charts)
    },

    async favourited({commit, dispatch}, payload) {
        let chart = payload
        let favourite = null

        try {
            commit("updating", chart.favourited());
            favourite = await store.get("charts/updating");
            commit("updating", false);
        } catch (error) {
            throw error
        }

        let user = store.get("auth/user")

        chart.favourites = chart.favourites.filter(favourite => favourite.user.id !== user.id)
        chart.favourites.push(favourite)
    },

    async unfavourited({commit, dispatch}, payload) {
        let chart = payload
        let favourite = null
        let user = store.get("auth/user")

        try {
            commit("updating", chart.unfavourited(user.id));
            favourite = await store.get("charts/updating");
            commit("updating", false);
        } catch (error) {
            throw error
        }

        chart.favourites = chart.favourites.filter(f => f.id !== favourite.id)
    },

    sendExportReport({ commit }, filter = true) {
        let client = new Client({id: store.get('auth/client@id')})
        let chart = new Chart().for(client)

        try {
            let filters = store.get("charts/filters")
            let limit = store.get("charts/limit")
            let pagination = store.get("charts/pagination")
            let query = chart
                .orderBy(store.get("charts/sortBy"))

            if (filter) {
                for (const key in filters) {
                    if (filters.hasOwnProperty(key)) {
                        if (key === 'tags') {
                            query = buildTagFilters(query, filters[key])
                        } else {
                            query.where(key, filters[key])

                            if (key === 'search' && filters[key].length !== 0) {
                                store.set("charts/pagination@current_page", 1)
                            }
                        }
                    }
                }

                query.page(store.get("charts/pagination@current_page"))
            }

            query.page(pagination.current_page).limit(limit)

            query.sendExportReport(client.id)
        } catch (error) {
            console.log(error);

        }
    },
};

const getters = {
    actions: (state) => {
        return chartId => {
            let chart = state.charts.find(chart => chart.id === chartId)

            if (!chart || !chart.actions) {
                return []
            }

            return chart.actions
        }
    },

    hasMoreActions: (state, getters) => {
        return chartId => {
            let chart = state.charts.find(chart => chart.id === chartId)

            if (!chart) {
                return false
            }

            return getters.totalActions > getters.actions.length
        }
    },

    hasMoreInsights: (state, getters) => {
        return chartId => {
            let chart = state.charts.find(chart => chart.id === chartId)

            if (!chart) {
                return false
            }

            return getters.totalInsights > getters.insights.length
        }
    },

    insightGivers: (state) => {
        return chartId => {
            let chart = state.charts.find(chart => chart.id === chartId)

            // if (!chart || !chart.insightGivers) {
            if (!chart || !chart.givers) {
                return []
            }

            // return chart.insightGivers
            return chart.givers
        }
    },

    insights: (state) => {
        return chartId => {
            let chart = state.charts.find(chart => chart.id === chartId)

            if (!chart || !chart.insights) {
                return []
            }

            return chart.insights
        }
    },

    totalActions: (state) => {
        return chartId => {
            let chart = state.charts.find(chart => chart.id === chartId)

            if (!chart || !chart.query_settings || !chart.query_settings.action || !chart.query_settings.action.pagination || !chart.query_settings.action.pagination.total) {
                return 0
            }

            return chart.query_settings.action.pagination.total
        }
    },

    totalInsights: (state) => {
        return chartId => {
            let chart = state.charts.find(chart => chart.id === chartId)

            if (!chart || !chart.query_settings || !chart.query_settings.insight || !chart.query_settings.insight.pagination || !chart.query_settings.insight.pagination.total) {
                return 0
            }

            return chart.query_settings.insight.pagination.total
        }
    },

    totalActiveActions: (state) => {
        return chartId => {
            let chart = state.charts.find(chart => chart.id === chartId)

            if (!chart || !chart.active_actions_count) {
                return 0
            }

            return chart.active_actions_count
        }
    },
}

const buildTagFilters = (query, tags) => {
    let categoryTags = tags
        .filter(tag => tag.type === 'category')
        .map(tag => tag.name)

    let channelTags = tags
        .filter(tag => tag.type === 'channel')
        .map(tag => tag.name)

    if (categoryTags) {
        query.whereIn('category_tags', categoryTags)
    }

    if (channelTags) {
        query.whereIn('channel_tags', channelTags)
    }

    return query
}

function MetricDataException(message) {
    this.message = message
    this.name = 'MetricDataException'
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
